import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api'

export function useActivity(limit = 10) {
  return useQuery({
    queryKey: ['activity', limit],
    queryFn: () => api.activity.list({ limit }),
    select: (res) => res.data,
  })
}
